import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageTitleComponent } from './page-title.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [
    PageTitleComponent
  ],
  imports: [
    RouterModule,
    CommonModule,
    TranslateModule,
    NgbPopoverModule,
  ],
  exports: [PageTitleComponent]
})
export class PageTitleModule { }
